import React, { useState } from 'react';
import { Button, Modal, Form, Input, Checkbox, message, Typography } from 'antd';
import axios from 'axios';
import { apiUrl } from './config';
import { normalizzaEmail, suggerisciCorrezione, erroreBloccante } from '../utils/email';

const { Text } = Typography;



const RegistrationRequestModal = () => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [privacyChecked, setPrivacyChecked] = useState(false);
    // Correzione proposta quando il dominio somiglia a uno noto ma non lo e'.
    const [correzione, setCorrezione] = useState(null);
    // Indirizzo che l'utente ha gia' confermato di voler usare cosi' com'e':
    // senza questo il suggerimento si ripresenterebbe a ogni invio.
    const [emailConfermata, setEmailConfermata] = useState(null);
    const [form] = Form.useForm();

    const showModal = () => setVisible(true);
    const handleCancel = () => setVisible(false);

    const onPrivacyChange = (e) => {
        setPrivacyChecked(e.target.checked);
    };

    const onFinish = async (values) => {
        if (!privacyChecked) {
            message.error("Devi accettare le norme sulla privacy prima di procedere.");
            return;
        }

        const email = normalizzaEmail(values.email);

        const errore = erroreBloccante(email);
        if (errore) {
            message.error(errore);
            return;
        }

        // Un dominio sbagliato non da' errore: la richiesta parte, la password
        // non arriva mai e la persona resta bloccata. Meglio chiedere conferma.
        const proposta = suggerisciCorrezione(email);
        if (proposta && email !== emailConfermata) {
            setCorrezione(proposta);
            return;
        }

        const payload = {
            ...values,
            email,
            privacyAccepted: privacyChecked, // Aggiungi la conferma della privacy
        };

        setLoading(true);
        try {
            const response = await axios.post(`${apiUrl}/api/auth/register-request`, payload);
            if (response.status === 200) {
                message.success('Richiesta di registrazione inviata con successo.');
                setVisible(false);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 400) {
                    message.error(error.response.data || 'Richiesta duplicata: una richiesta con questa email esiste già.');
                } else if (error.response.status === 500) {
                    message.error('Errore del server, riprova più tardi.');
                } else {
                    message.error('Si è verificato un errore, riprova più tardi.');
                }
            } else {
                message.error('Impossibile connettersi al server. Verifica la tua connessione e riprova.');
            }
        } finally {
            setLoading(false);
        }
    };

    // L'indirizzo proposto sostituisce quello scritto; l'utente puo' anche
    // confermare il proprio, perche' i domini validi non finiscono in un elenco.
    const accettaCorrezione = () => {
        form.setFieldsValue({ email: correzione });
        setEmailConfermata(correzione);
        setCorrezione(null);
        form.submit();
    };

    // L'utente tiene il proprio indirizzo: si prende nota e non si insiste piu'.
    const mantieniIndirizzo = () => {
        setEmailConfermata(normalizzaEmail(form.getFieldValue('email')));
        setCorrezione(null);
        form.submit();
    };

    const buttonStyle = {
        fontSize: '16px',
        borderRadius: '4px',
        width: '100%',
        textAlign: 'center',
        padding: '10px',
        cursor: 'pointer',
        marginBottom: '20px',
        marginTop: '20px',
        color: 'var(--primario)',
        fontFamily: 'Neue Kaine, sans-serif',
    };

    return (
        <>
            <div style={{ marginTop: '20px', overflow: 'hidden' }}>
                <Text
                    type="secondary" 
                    onClick={showModal}
                    style={buttonStyle}
                >
                Richiedi Accesso Palestra
                    </Text>
            </div>
            <Modal
                title="Richiedi Accesso Palestra"
                open={visible}
                style={{ top: '10vh'}}
                getContainer={document.body}
                onCancel={handleCancel}
                footer={null}
            >
                <Form form={form} onFinish={onFinish}>
                    <Form.Item name="nome" label="Nome" rules={[{ required: true, message: 'Inserisci il nome!' }]}>
                        <Input placeholder="Inserisci il nome" />
                    </Form.Item>
                    <Form.Item name="cognome" label="Cognome" rules={[{ required: true, message: 'Inserisci il cognome!' }]}>
                        <Input placeholder="Inserisci il cognome" />
                    </Form.Item>
                    <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email', message: 'Inserisci una email valida!' }]}>
                        <Input placeholder="Inserisci la tua email" />
                    </Form.Item>
                    <Form.Item name="note" label="Note">
                        <Input.TextArea placeholder="Inserisci eventuali note (es: faccio solo sala pesi)" />
                    </Form.Item>

                    <Form.Item>
                        <Checkbox onChange={onPrivacyChange}>
                            Ho letto e accetto le <a href="https://drive.google.com/file/d/116gIE8LiiicnStRzwwCpZ2Tb5l6renfN/view?usp=sharing" target="_blank" rel="noopener noreferrer">norme sulla privacy</a>.
                        </Checkbox>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={loading}>
                            Invia Richiesta
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Controlla l'indirizzo email"
                open={!!correzione}
                onOk={accettaCorrezione}
                onCancel={mantieniIndirizzo}
                okText={`Sì, correggi`}
                cancelText="No, è giusto così"
                getContainer={document.body}
                className="custom-modal"
            >
                <p>Forse intendevi <strong>{correzione}</strong>?</p>
                <p style={{ color: 'var(--testo-tenue)', marginBottom: 0 }}>
                    La password di accesso arriva per email: se l'indirizzo è sbagliato
                    non la riceverai.
                </p>
            </Modal>
        </>
    );
};

export default RegistrationRequestModal;
